import * as React from 'react';
import { Badge } from '../badge/badge';
import { Enum } from 'core/domain/commons/common';

/** Mirrors LevelUniqueName on the backend; any level above Level0 means the user is authenticated. */
const LEVEL0 = 1;

interface Props {
    level?: Enum | null;
}

export const UserAuthBadge: React.FC<Props> = ({ level }) => {
    if (!level) return <>-</>;

    return level.id === LEVEL0 ? (
        <Badge text="احراز نشده" type="error" />
    ) : (
        <Badge text={`احراز شده (${level.title})`} type="success" />
    );
};
